<app-admin-page-header
  eyebrow="Analyse"
  title="Statistiques"
  subtitle="Choisis une période pour voir l'activité du groupe et les membres les plus assidus.">
</app-admin-page-header>

<!-- Période -->
<div class="bg-white rounded-xl border border-gray-200 p-5 shadow-sm mb-6">
  <div class="flex flex-col lg:flex-row lg:items-end gap-4 lg:justify-between">
    <div class="flex flex-wrap gap-2">
      <button type="button" (click)="applyPreset('annee')"
        class="px-3 py-1.5 text-sm font-raleway font-semibold rounded-lg border transition-colors"
        [class.bg-primary]="activePreset === 'annee'" [class.text-white]="activePreset === 'annee'" [class.border-primary]="activePreset === 'annee'"
        [class.bg-white]="activePreset !== 'annee'" [class.text-gray-700]="activePreset !== 'annee'" [class.border-gray-300]="activePreset !== 'annee'">
        Cette année
      </button>
      <button type="button" (click)="applyPreset('12mois')"
        class="px-3 py-1.5 text-sm font-raleway font-semibold rounded-lg border transition-colors"
        [class.bg-primary]="activePreset === '12mois'" [class.text-white]="activePreset === '12mois'" [class.border-primary]="activePreset === '12mois'"
        [class.bg-white]="activePreset !== '12mois'" [class.text-gray-700]="activePreset !== '12mois'" [class.border-gray-300]="activePreset !== '12mois'">
        12 derniers mois
      </button>
      <button type="button" (click)="applyPreset('tout')"
        class="px-3 py-1.5 text-sm font-raleway font-semibold rounded-lg border transition-colors"
        [class.bg-primary]="activePreset === 'tout'" [class.text-white]="activePreset === 'tout'" [class.border-primary]="activePreset === 'tout'"
        [class.bg-white]="activePreset !== 'tout'" [class.text-gray-700]="activePreset !== 'tout'" [class.border-gray-300]="activePreset !== 'tout'">
        Depuis la création
      </button>
    </div>

    <div class="flex flex-wrap items-end gap-3">
      <div>
        <label for="dateDebut" class="block mb-1 text-xs font-raleway font-semibold text-gray-500">Du</label>
        <input id="dateDebut" type="date" [(ngModel)]="dateDebut" (ngModelChange)="onCustomRangeChange()"
          class="px-3 py-2 text-sm font-raleway bg-gray-50 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary/30 focus:border-primary">
        </div>
        <div>
          <label for="dateFin" class="block mb-1 text-xs font-raleway font-semibold text-gray-500">Au</label>
          <input id="dateFin" type="date" [(ngModel)]="dateFin" (ngModelChange)="onCustomRangeChange()"
            class="px-3 py-2 text-sm font-raleway bg-gray-50 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary/30 focus:border-primary">
          </div>
        </div>
      </div>
    </div>

    <!-- KPI cards -->
    <div class="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
      <div class="bg-white rounded-xl border border-gray-200 p-5 shadow-sm">
        <p class="text-xs uppercase tracking-wider font-semibold text-gray-400">Sorties</p>
        <p class="text-3xl font-alice text-blue-dark mt-1">{{ nbSorties }}</p>
        <p class="text-xs text-gray-500 mt-1">Sur la période choisie</p>
      </div>
      <div class="bg-white rounded-xl border border-gray-200 p-5 shadow-sm">
        <p class="text-xs uppercase tracking-wider font-semibold text-gray-400">Présences</p>
        <p class="text-3xl font-alice text-blue-dark mt-1">{{ nbPresences }}</p>
        <p class="text-xs text-gray-500 mt-1">Total de participations enregistrées</p>
      </div>
      <div class="bg-white rounded-xl border border-gray-200 p-5 shadow-sm">
        <p class="text-xs uppercase tracking-wider font-semibold text-gray-400">Participants</p>
        <p class="text-3xl font-alice text-blue-dark mt-1">{{ nbParticipantsUniques }}</p>
        <p class="text-xs text-gray-500 mt-1">Membres distincts ayant participé</p>
      </div>
      <div class="bg-white rounded-xl border border-gray-200 p-5 shadow-sm">
        <p class="text-xs uppercase tracking-wider font-semibold text-gray-400">Moyenne</p>
        <p class="text-3xl font-alice text-blue-dark mt-1">{{ moyennePresencesParSortie | number:'1.0-1' }}</p>
        <p class="text-xs text-gray-500 mt-1">Présences par sortie</p>
      </div>
    </div>

    <div class="grid grid-cols-1 lg:grid-cols-3 gap-4">
      <!-- Classement des membres -->
      <div class="lg:col-span-2 bg-white rounded-xl border border-gray-200 shadow-sm">
        <div class="flex items-center justify-between px-5 py-4 border-b border-gray-100">
          <div>
            <p class="text-xs uppercase tracking-wider font-semibold text-gray-400">Classement</p>
            <h3 class="text-lg font-alice text-blue-dark">Membres les plus assidus</h3>
          </div>
          @if (classement.length > 0) {
            <span class="inline-flex items-center gap-1.5 text-sm font-raleway text-gray-600">
              <svg class="w-4 h-4 text-amber-500" fill="currentColor" viewBox="0 0 24 24"><path d="M5 3a1 1 0 000 2v6a5.002 5.002 0 004 4.9V17H7a1 1 0 100 2h6a1 1 0 100-2h-2v-1.1a5.002 5.002 0 004-4.9V5a1 1 0 100-2H5z"/></svg>
              {{ classement[0].nom_prenom }} · {{ classement[0].count }} sortie{{ classement[0].count > 1 ? 's' : '' }}
            </span>
          }
        </div>

        <ul class="divide-y divide-gray-100">
          @for (m of classement; track m; let i = $index) {
            <li class="px-5 py-3">
              <div class="flex items-center gap-4">
                <span class="w-6 text-sm font-alice text-gray-400 text-center shrink-0">{{ i + 1 }}</span>
                <div class="min-w-0 flex-1">
                  <div class="flex items-center justify-between gap-2 mb-1">
                    <p class="text-sm font-raleway font-semibold text-gray-800 truncate">{{ m.nom_prenom }}</p>
                    <p class="text-sm font-raleway font-semibold text-blue-dark shrink-0">{{ m.count }}</p>
                  </div>
                  <div class="w-full h-2 rounded-full bg-gray-100 overflow-hidden">
                    <div class="h-full rounded-full bg-primary" [class.bg-amber-500]="i === 0" [style.width.%]="barWidth(m.count)"></div>
                  </div>
                </div>
              </div>
            </li>
          }
          @if (!loading && classement.length === 0) {
            <li class="px-5 py-10 text-center text-sm text-gray-400 font-raleway">
              Aucune présence enregistrée sur cette période.
            </li>
          }
        </ul>
      </div>

      <!-- Top événements -->
      <div class="bg-white rounded-xl border border-gray-200 shadow-sm">
        <div class="px-5 py-4 border-b border-gray-100">
          <p class="text-xs uppercase tracking-wider font-semibold text-gray-400">Fréquentation</p>
          <h3 class="text-lg font-alice text-blue-dark">Sorties les plus suivies</h3>
        </div>
        <ul class="divide-y divide-gray-100">
          @for (e of topEvenements; track e) {
            <li class="px-5 py-3">
              <p class="text-sm font-raleway font-semibold text-gray-800 truncate">{{ e.nom }}</p>
              <div class="flex items-center justify-between mt-0.5">
                <p class="text-xs text-gray-500">{{ formatDate(e.dateDebut) }}</p>
                <p class="text-xs font-raleway font-semibold text-primary">{{ e.count }} présent.e.s</p>
              </div>
            </li>
          }
          @if (!loading && topEvenements.length === 0) {
            <li class="px-5 py-10 text-center text-sm text-gray-400 font-raleway">
              Aucune donnée sur cette période.
            </li>
          }
        </ul>
      </div>
    </div>
